module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-[13]12.ce491de.woff2";